import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api, { getToken, getAdminUser, saveSession, clearSession } from "../lib/adminApi";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [ready, setReady] = useState(false);
  const [token, setToken] = useState(null);
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const t = getToken();
    const a = getAdminUser();
    if (t && a) {
      setToken(t);
      setAdmin(a);
    }
    setReady(true);
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    const { token: jwt, admin: adm } = res.data;
    saveSession(jwt, adm);
    setToken(jwt);
    setAdmin(adm);
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch { /* silent */ }
    clearSession();
    setToken(null);
    setAdmin(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ ready, token, admin, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const v = useContext(AuthCtx);
  if (!v) throw new Error("useAuth must be used inside AuthProvider");
  return v;
}
